import type { SourceCard } from "../Types/SourceTypes";

export const BASE_SOURCES: SourceCard[] = [
  { name: "Shopify", icon: "/Icons/Shopify.svg", className: "shopify" },
  { name: "Facebook", icon: "/Icons/FB.svg", className: "facebook" },
  { name: "GoogleAds", icon: "/Icons/Ads.svg", className: "google-ads" },
  {
    name: "GoogleAnalytics4",
    icon: "/Icons/GA.svg",
    className: "google-analytics",
  },
  { name: "Instagram", icon: "/Icons/Instalogo.png", className: "instagram" },
];

export const ODOO_SOURCE: SourceCard = {
  name: "Odoo",
  icon: "/images/odoo.svg",
  className: "odoo",
};

export const SOURCE_ID_TO_NAME_MAP: Record<number, string> = {
  1: "Shopify",
  2: "Facebook",
  4: "GoogleAds",
  5: "GoogleAnalytics4",
  6: "Odoo",
};

export const ONBOARDING_SOURCE_ID_TO_NAME_MAP: Record<number, string> = {
  1: "Shopify",
  2: "Facebook",
  3: "Instagram",
  4: "GoogleAds",
  5: "GoogleAnalytics",
};

export const ONBOARDING_SOCIAL_MEDIA_ORDER: string[] = [
  "Shopify",
  "GoogleAds",
  "GoogleAnalytics",
  "Meta",
  "Facebook",
  "Instagram",
  "Snapchat",
  "Finish",
];
